<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">9. Redes referenciadas</div>
    <div v-if="!loading">
      <div style="min-height: 496px" v-if="qtTotal > 0">
        <unicom-linha
          :class="{ par: index % 2 === 0 }"
          :espacamento="false"
          class="espacamento-rede-referenciada medio"
          v-for="(info, index) in rowsComputed"
          :key="index"
        >
          <unicom-coluna
            sm="auto"
            style="padding-right: 34px"
            :class="$breakpoint.smAndDown ? 'mb-2' : ''"
          >
            <div>
              {{ zeroEsquerda(index + 1, 2) }}
            </div>
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            md="5"
            :class="$breakpoint.smAndDown ? 'mb-2' : ''"
          >
            <div>
              <span class="segunda-cor-fonte">
                {{ nomeCampos["codigoRedeReferenciada"] }}:
              </span>
              <span class="padding-left: 8px">
                {{ info.codigo }}
              </span>
            </div>
          </unicom-coluna>
          <unicom-coluna sm="12" md="6">
            <div>
              <span class="segunda-cor-fonte">
                {{ nomeCampos["descricaoRede"] }}:
              </span>
              <span class="padding-left: 8px">
                {{ info.nome }}
              </span>
            </div>
          </unicom-coluna>
        </unicom-linha>
      </div>
      <unicom-paginacao-v3
        v-if="qtTotal > 0"
        :mostrarBotaoUltimo="false"
        textoExibindo="resultados"
        :qtPaginaAtual="qtPaginaAtual"
        :qtTotal="this.zeroEsquerda(qtTotal, 2)"
        :qtPaginas="qtPaginas"
        v-model="pagina"
      />
      <div class="medio negrito" v-else>
        Não contém nenhuma rede referenciada
      </div>
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      v-show="loading"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";
import TabelaFrontMixin from "@/shared/mixin/TabelaFrontMixin";

export default {
  name: "RedesPreferenciadas",
  mixins: [DadosGeraisMixin, TabelaFrontMixin],
  data() {
    return {
      nomeCampos: {
        codigoRedeReferenciada: "Código da rede referenciada",
        descricaoRede: "Descrição da rede"
      },
      pagina: 1
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getRedeReferenciada(this.idRnpPrestador)
          .then(res => {
            this.rows = res.data;
            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.espacamento-rede-referenciada {
  padding: 16px;
  padding-left: 24px;
}

.par {
  background: #f2f5f4;
}
</style>
